import { render, staticRenderFns } from "./status-group.vue?vue&type=template&id=20f7d719&"
import script from "./status-group.vue?vue&type=script&lang=js&"
export * from "./status-group.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports